export default "__VITE_ASSET__d238e66a__"